/** Max links stored on a project (API + form validation). */
export const EXTERNAL_LINKS_MAX = 30

/** Show inline list when count is at most this; otherwise open modal via button. */
export const EXTERNAL_LINKS_INLINE_MAX = 4
